export const getContactsPageNextjsUrl = () => '/contacts'
